import React, { type ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@shared/context/AuthContext";
import { canSignReports } from "@shared/utils/roleRegistry";

const sections = [
  { label: "Profile", href: "/account/profile" },
  { label: "Signature", href: "/account/profile?tab=signature" },
  { label: "Preferences", href: "/account/preferences/general" },
  { label: "MFA & passkeys", href: "/account/security/mfa" },
  { label: "Password", href: "/account/security/password" },
  { label: "Sessions", href: "/account/sessions" },
  { label: "Activity", href: "/account/security/activity" },
] as const;

export default function AccountHubNav({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { user } = useAuth();
  const current = `${location.pathname}${location.search}`;
  const isCurrent = (label: string, href: string) =>
    current === href ||
    (label === "Preferences" && location.pathname.startsWith("/account/preferences/")) ||
    (label === "MFA & passkeys" && ["/account/security/mfa", "/account/security/passkeys"].includes(location.pathname));
  return <div>
    <nav className="nav nav-tabs px-3 pt-3" aria-label="Account sections">
      {sections.filter(({ label }) => label !== "Signature" || canSignReports(user)).map(({ label, href }) => <Link
        key={href}
        to={href}
        className={`nav-link ${isCurrent(label, href) ? "active" : ""}`}
        aria-current={isCurrent(label, href) ? "page" : undefined}
      >{label}</Link>)}
    </nav>
    {children}
  </div>;
}
